export class UserLogEntry {
  id?: string;

  userAction: UserActionType;
  userActionDisplay?: string;

  userActionTime?: Date;
  supplerPid?: string;
  groupString?: string;
  catalog?: string;
  catalogId?: string;

  user?: string;
  userId?: string;

  customer?: string;
  customerId?: string;
}

export enum UserActionType {
  UserDeleteProduct = 0,
  UserDeleteCategory = 1
}

export const UserActionTypeLabel: Record<UserActionType, string> = {
  [UserActionType.UserDeleteProduct]: 'User Product Delete',
  [UserActionType.UserDeleteCategory]: 'User Category Delete',
};
